// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"e386dfde","174":"208366d0","239":"fae07908","429":"ef13b5d2","453":"6c0734eb","568":"82ca0143","749":"b69d89a7","868":"56c65868","893":"bffcda98"}[chunkId] + ".chunk.js";
};